import { useTranslation } from "react-i18next";
import { useFontStyle } from "~/hook/useFontStyle";
import { useAppSelector } from "~/lib/store/store";
import { cn } from "~/lib/utils";
import Points from "~/svg/Points";
import Quizzes from "~/svg/Quizzes";
import Strike from "~/svg/Strike";

function QuizStats() {
  const { t } = useTranslation();
  const { medium } = useFontStyle();
  const { stats } = useAppSelector((state) => state.satsangQuiz);
  const statsData = [
    {
      icon: <Quizzes height={45} width={45} />,
      label: t("satsang_quiz.total_quizzes"),
      value: stats?.played_quiz || 0,
    },
    {
      icon: <Points height={45} width={45} />,
      label: t("satsang_quiz.total_points"),
      value: stats?.earning_points || 0,
    },
    {
      icon: <Strike height={45} width={45} />,
      label: t("satsang_quiz.strike"),
      value: stats?.strike || 0,
    },
  ];
  return (
    <div className="w-full flex justify-center items-center">
      <div className="w-full md:w-[70%] grid grid-cols-3">
        {statsData.map((stat, index) => (
          <div
            className={cn(
              "w-full flex flex-col justify-center items-center p-2 gap-2",
              index !== statsData.length - 1 && "border-r border-borderPrimary",
            )}
            key={index}
          >
            {stat.icon}
            <div className="w-full flex max-md:flex-col justify-center items-center md:gap-2">
              <span className={cn("text-14 md:text-16 text-textColor text-center", medium)}>
                {stat.label} <span className="hidden md:inline">:</span>
              </span>
              <span className="text-xl text-textHeadingColor font-abcArizonaFlareVariable font-medium">{stat.value}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default QuizStats;
